// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___2ghJ6","open":"open___xkVyq","loading":"loading___2L67P"};